import * as XLSX from 'xlsx'
import type { Candidate } from '../types'

/**
 * Export candidates data to Excel file
 */
export const exportCandidatesToExcel = (
  candidates: Candidate[],
  filename: string = 'candidatos'
) => {
  // Prepare data for Excel export
  const excelData = candidates.map(candidate => ({
    Nombre: `${candidate.nombres} ${candidate.apellidos}`,
    Cargo: candidate.cargo || '',
    'Match %': candidate.match ? `${candidate.match}%` : '-',
    Estado: getQualificationStatusText(
      candidate.qualification_status || 'pendiente'
    ),
    Fecha: new Date(candidate.fecha_registro).toLocaleDateString('es-ES'),
    Email: candidate.correo || '',
    Teléfono: candidate.telefono || '',
  }))

  // Create workbook and worksheet
  const workbook = XLSX.utils.book_new()
  const worksheet = XLSX.utils.json_to_sheet(excelData)

  // Set column widths for better readability
  const columnWidths = [
    { wch: 25 }, // Nombre
    { wch: 30 }, // Cargo
    { wch: 10 }, // Match %
    { wch: 15 }, // Estado
    { wch: 12 }, // Fecha
    { wch: 25 }, // Email
    { wch: 15 }, // Teléfono
  ]
  worksheet['!cols'] = columnWidths

  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Candidatos')

  // Generate filename with timestamp
  const timestamp = new Date().toISOString().slice(0, 10)
  const finalFilename = `${filename}_${timestamp}.xlsx`

  // Save file
  XLSX.writeFile(workbook, finalFilename)
}

/**
 * Get human-readable text for qualification status
 */
const getQualificationStatusText = (status: string): string => {
  const statusMap: Record<string, string> = {
    pendiente: 'Pendiente',
    califica: 'Califica',
    no_califica: 'No Califica',
  }
  return statusMap[status] || status
}

/**
 * Export selected candidates to Excel
 */
export const exportSelectedCandidatesToExcel = (
  candidates: Candidate[],
  selectedIds: Set<string>,
  filename: string = 'candidatos_seleccionados'
) => {
  const selectedCandidates = candidates.filter(candidate =>
    selectedIds.has(candidate.id_postulacion)
  )
  exportCandidatesToExcel(selectedCandidates, filename)
}
